(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["easylonger-accessories-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (window.EasyLongerAccessoriesMotion || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  window.EasyLongerAccessoriesMotion = true;
  const selector = '.el-accessories-v3 > .el-directory-v3__width > header, .el-accessories-v3__routes > article, .el-directory-v3-products .el-directory-v3-card, .el-directory-v3-final > .el-directory-v3__width > *';
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const pending = new Set();
  const running = new Map();
  let suspended = false;
  const finish = (item) => {
    seen.add(item);
    observer.unobserve(item);
    pending.delete(item);
    const animation = running.get(item);
    running.delete(item);
    animation?.cancel();
  };
  const observer = new IntersectionObserver((entries) => {
    const groups = new Map();
    entries.forEach((entry) => {
      const item = entry.target;
      if (!entry.isIntersecting || !pending.has(item)) return;
      finish(item);
      if (suspended || preference.matches || !item.isConnected || item.contains(document.activeElement) || entry.boundingClientRect.bottom <= 0) return;
      const order = groups.get(item.parentElement) || 0;
      groups.set(item.parentElement, order + 1);
      try {
        const animation = item.animate([
          { opacity: 0.7, transform: 'translateY(16px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], { duration: 550, delay: Math.min(order * 70, 140), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' });
        running.set(item, animation);
        animation.onfinish = () => finish(item);
      } catch (_) {}
    });
  }, { threshold: 0, rootMargin: '0px 0px -24px 0px' });
  const init = () => {
    const main = document.querySelector('.el-directory-v3-hero--accessories')?.closest('main');
    if (!main || suspended || preference.matches) return;
    main.querySelectorAll(selector).forEach((item) => {
      if (seen.has(item) || pending.has(item)) return;
      if (item.getBoundingClientRect().top < window.innerHeight || item.contains(document.activeElement)) {
        seen.add(item);
        return;
      }
      pending.add(item);
      observer.observe(item);
    });
  };
  const stop = () => {
    observer.disconnect();
    pending.clear();
    Array.from(running.keys()).forEach(finish);
  };
  document.addEventListener('focusin', (event) => {
    const item = event.target.closest?.(selector);
    if (item && (pending.has(item) || running.has(item))) finish(item);
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    new Set([...pending, ...running.keys()]).forEach((item) => {
      if (event.target.contains(item)) finish(item);
    });
  });
  preference.addEventListener('change', () => { stop(); init(); });
  window.addEventListener('pagehide', () => { suspended = true; stop(); });
  window.addEventListener('pageshow', () => { suspended = false; init(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easylonger-cable-videos"] && !Shopify.designMode) return;
  try {
    
  function initializeCableVideos(root) {
    root.querySelectorAll('[data-cable-video]').forEach(item => {
      if (item.dataset.initialized) return;
      item.dataset.initialized = 'true';
      const video = item.querySelector('video');
      const error = item.querySelector('[data-cable-video-error]');
      const failedSources = new Set();
      video.addEventListener('error', event => {
        if (event.target === video) { error.hidden = false; return; }
        if (event.target.tagName !== 'SOURCE') return;
        failedSources.add(event.target);
        if (failedSources.size >= video.querySelectorAll('source').length) error.hidden = false;
      }, true);
      video.addEventListener('loadeddata', () => { failedSources.clear(); error.hidden = true; });
      item.querySelector('[data-cable-video-retry]').addEventListener('click', () => {
        failedSources.clear();
        error.hidden = true;
        video.load();
        video.focus();
      });
    });
  }
  initializeCableVideos(document);
  document.addEventListener('shopify:section:load', event => initializeCableVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easylonger-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('el-announcement-slider')) {
    customElements.define('el-announcement-slider', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.rotationTimer);
        clearTimeout(this.settleTimer);
        this.resizeObserver?.disconnect();
        this.controller = new AbortController();
        this.track = this.querySelector('[data-announcement-track]');
        this.items = Array.from(this.querySelectorAll('.el-announcement__item'));
        this.status = this.querySelector('[data-announcement-status]');
        if (!this.track || !this.items.length) return;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.activeIndex = 0;
         this.hovered = false;
        const options = { signal: this.controller.signal };
        const previous = this.querySelector('[data-announcement-previous]');
        const next = this.querySelector('[data-announcement-next]');
         previous.hidden = this.items.length < 2;
         next.hidden = this.items.length < 2;
         previous.addEventListener('click', () => this.manualGo((this.pendingIndex ?? this.currentIndex()) - 1), options);
         next.addEventListener('click', () => this.manualGo((this.pendingIndex ?? this.currentIndex()) + 1), options);
        this.addEventListener('pointerenter', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = true;
          this.stopRotation();
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType !== 'mouse') return;
          this.hovered = false;
          this.scheduleRotation();
        }, options);
        this.addEventListener('focusin', () => this.stopRotation(), options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.scheduleRotation(true);
        }, options);
        this.addEventListener('keydown', event => {
          if (event.altKey || event.ctrlKey || event.metaKey) return;
          const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          const index = this.pendingIndex ?? this.currentIndex();
          let target;
          if (event.key === 'ArrowLeft') target = index - direction;
          if (event.key === 'ArrowRight') target = index + direction;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.items.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.manualGo(target);
          if (this.track.contains(event.target)) this.items[this.pendingIndex].querySelector('a').focus({ preventScroll: true });
        }, options);
        this.track.addEventListener('focusin', event => {
          const index = this.items.findIndex(item => item.contains(event.target));
          if (index >= 0) this.go(index, false, true);
        }, options);
        this.track.addEventListener('pointerdown', () => { this.pendingIndex = null; this.stopRotation(); }, options);
        this.track.addEventListener('pointerup', () => this.scheduleRotation(), options);
        this.track.addEventListener('pointercancel', () => this.scheduleRotation(), options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => {
            this.pendingIndex = null;
            this.activeIndex = this.currentIndex();
          }, 150);
        }, { ...options, passive: true });
         this.motion.addEventListener('change', () => this.scheduleRotation(true), options);
        document.addEventListener('visibilitychange', () => this.scheduleRotation(), options);
        window.addEventListener('pagehide', () => this.stopRotation(), options);
        window.addEventListener('pageshow', () => this.scheduleRotation(), options);
        this.resizeObserver = new ResizeObserver(() => this.go(this.activeIndex, false, true));
        this.resizeObserver.observe(this.track);
         this.scheduleRotation();
      }
      stopRotation() {
        clearTimeout(this.rotationTimer);
      }
      scheduleRotation(focusLeaving = false) {
        this.stopRotation();
         if (this.items.length < 2 || this.motion.matches || this.hovered || document.hidden) return;
        if (!focusLeaving && this.contains(document.activeElement)) return;
        this.rotationTimer = setTimeout(() => {
          if (!this.isConnected || this.contains(document.activeElement)) return;
          this.go(this.currentIndex() + 1, false);
          this.scheduleRotation();
        }, 7000);
      }
      manualGo(index) {
        this.go(index);
        this.scheduleRotation();
      }
      currentIndex() {
        return Math.min(this.items.length - 1, Math.max(0, Math.round(Math.abs(this.track.scrollLeft) / Math.max(1, this.track.clientWidth))));
      }
      go(index, announce = true, immediate = false) {
        const target = ((index % this.items.length) + this.items.length) % this.items.length;
        const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pendingIndex = target;
        this.activeIndex = target;
        this.track.scrollTo({ left: direction * target * this.track.clientWidth, behavior: immediate || reducedMotion ? 'instant' : 'smooth' });
        if (announce) this.status.textContent = this.items[target].textContent.trim();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.stopRotation();
        this.resizeObserver?.disconnect();
        clearTimeout(this.settleTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easylonger-learn-articles"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-el-blog-hub]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';

    const cards = Array.from(section.querySelectorAll('[data-article-card]'));
    const filters = Array.from(section.querySelectorAll('[data-blog-filter]'));
    const loadMore = section.querySelector('[data-blog-load-more]');
    const visibleCount = section.querySelector('[data-visible-count]');
    const matchingCount = section.querySelector('[data-matching-count]');
    const pageSize = Number.parseInt(section.dataset.pageSize || '12', 10);
    const validFilters = new Set(filters.map((button) => button.dataset.blogFilter));
    let activeFilter = new URL(window.location.href).searchParams.get('topic') || 'all';
    let visibleLimit = pageSize;

    if (!validFilters.has(activeFilter)) activeFilter = 'all';

    const syncUrl = () => {
      const url = new URL(window.location.href);
      if (activeFilter === 'all') url.searchParams.delete('topic');
      else url.searchParams.set('topic', activeFilter);
      window.history.pushState({}, '', url);
    };

    const render = () => {
      const matchingCards = cards.filter((card) => activeFilter === 'all' || card.dataset.channel === activeFilter);
      const shownCards = matchingCards.slice(0, visibleLimit);

      cards.forEach((card) => {
        card.hidden = !shownCards.includes(card);
        card.classList.remove('is-featured');
      });
      if (shownCards[0]) shownCards[0].classList.add('is-featured');

      filters.forEach((button) => {
        const selected = button.dataset.blogFilter === activeFilter;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      visibleCount.textContent = String(shownCards.length);
      matchingCount.textContent = String(matchingCards.length);

      const remaining = matchingCards.length - shownCards.length;
      loadMore.hidden = remaining <= 0;
      if (remaining > 0) loadMore.textContent = `Show ${Math.min(pageSize, remaining)} more articles`;
    };

    filters.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.blogFilter;
        visibleLimit = pageSize;
        syncUrl();
        render();
      });
    });

    loadMore.addEventListener('click', () => {
      visibleLimit += pageSize;
      render();
    });

    window.addEventListener('popstate', () => {
      const requestedFilter = new URL(window.location.href).searchParams.get('topic') || 'all';
      activeFilter = validFilters.has(requestedFilter) ? requestedFilter : 'all';
      visibleLimit = pageSize;
      render();
    });

    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easylonger-product-source-media"] && !Shopify.designMode) return;
  try {
    
(() => {
  const activeSections = new WeakMap();
  function setup(section) {
    if (activeSections.has(section)) return;
    const viewer = section.querySelector('[data-source-viewer]');
    const image = viewer?.querySelector('[data-source-viewer-image]');
    const stage = viewer?.querySelector('[data-source-scale]');
    const viewport = viewer?.querySelector('[data-source-viewport]');
    const close = viewer?.querySelector('[data-source-close]');
    if (!viewer || !image || !stage || !viewport || !close) return;
    const controller = new AbortController();
    const on = (element, type, handler) => element?.addEventListener(type, handler, { signal: controller.signal });
    const media = window.matchMedia('(max-width: 767px)');
    const previous = viewer.querySelector('[data-source-prev]');
    const next = viewer.querySelector('[data-source-next]');
    const position = viewer.querySelector('[data-source-position]');
    const loading = viewer.querySelector('[data-source-loading]');
    const error = viewer.querySelector('[data-source-image-error]');
    const retry = viewer.querySelector('[data-source-retry]');
    const title = viewer.querySelector('[data-source-viewer-title]');
    let launch = null;
    let groupRoot = null;
    let group = [];
    let index = 0;
    let priorOverflow = '';
    let launchScroll = null;
    let launchViewport = null;
    let locked = false;
    let request = null;
    let generation = 0;
    let returnGeneration = 0;
    let returnActive = false;
    let pendingCloseEvents = 0;

    const record = link => {
      if (media.matches && link.closest('.el-story-desktop-only')) return null;
      const original = link.querySelector('img');
      const mobileSource = link.querySelector('source');
      const mobile = media.matches && Boolean(link.dataset.sourceMobileUrl);
      const url = mobile ? link.dataset.sourceMobileUrl : link.dataset.sourceDesktopUrl || link.getAttribute('href');
      if (!url || !original) return null;
      return {
        link,
        url,
        alt: (mobile ? link.dataset.sourceMobileAlt : link.dataset.sourceDesktopAlt) || original.alt || '',
        title: link.dataset.sourceTitle || '',
        width: Math.max(1, Number((mobile ? mobileSource : original)?.getAttribute('width')) || 1),
        height: Math.max(1, Number((mobile ? mobileSource : original)?.getAttribute('height')) || 1)
      };
    };
    const readGroup = () => [...groupRoot.querySelectorAll('.el-source-media__image-link')].map(record).filter(Boolean);
    const fit = () => {
      stage.setAttribute('aria-pressed', 'false');
      stage.setAttribute('aria-label', section.dataset.sourceZoomInLabel);
      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;
    };
    const navigation = () => {
      if (previous) { previous.hidden = group.length < 2; previous.setAttribute('aria-disabled', String(index === 0)); }
      if (next) { next.hidden = group.length < 2; next.setAttribute('aria-disabled', String(index === group.length - 1)); }
      if (position) position.textContent = (viewer.dataset.sourcePositionTemplate || '__CURRENT__ / __TOTAL__').replace('__CURRENT__', String(index + 1)).replace('__TOTAL__', String(group.length));
    };
    const fail = () => {
      viewer.dataset.sourceState = 'error';
      viewport.setAttribute('aria-busy', 'false');
      image.hidden = true;
      stage.disabled = true;
      if (loading) loading.hidden = true;
      if (error) error.hidden = false;
    };
    const populate = () => {
      const item = group[index];
      if (!item) return;
      request?.abort();
      request = new AbortController();
      const token = ++generation;
      viewer.dataset.sourceState = 'loading';
      viewport.setAttribute('aria-busy', 'true');
      if (loading) loading.hidden = false;
      if (error) error.hidden = true;
      image.hidden = true;
      image.width = item.width;
      image.height = item.height;
      image.alt = item.alt;
      stage.disabled = true;
      if (title) title.textContent = item.title || item.alt;
      fit();
      navigation();
      const loader = new Image();
      loader.decoding = 'async';
      loader.addEventListener('load', () => {
        if (token !== generation || !viewer.open) return;
        image.width = loader.naturalWidth || item.width;
        image.height = loader.naturalHeight || item.height;
        image.src = item.url;
        stage.style.setProperty('--source-native-width', `${image.width}px`);
        viewer.dataset.sourceState = 'ready';
        viewport.setAttribute('aria-busy', 'false');
        if (loading) loading.hidden = true;
        image.hidden = false;
        stage.disabled = false;
      }, { signal: request.signal, once: true });
      loader.addEventListener('error', () => {
        if (token === generation && viewer.open) fail();
      }, { signal: request.signal, once: true });
      loader.src = item.url;
    };
    const visible = target => target?.isConnected && target.getClientRects().length && window.getComputedStyle(target).visibility !== 'hidden';
    const cancelReturn = () => {
      if (!returnActive) return;
      returnActive = false;
      returnGeneration++;
    };
    const open = link => {
      if (typeof viewer.showModal !== 'function') return false;
      if (viewer.open) return true;
      groupRoot = section.classList.contains('el-catalog-stories--battery') ? section : link.closest('.el-story') || link.closest('[data-source-module]') || section;
      group = readGroup();
      index = group.findIndex(item => item.link === link);
      if (index < 0) return false;
      launch = link;
      returnActive = false;
      returnGeneration++;
      launchScroll = { left: window.scrollX, top: window.scrollY };
      const launchRect = link.getBoundingClientRect();
      launchViewport = { left: launchRect.left, top: launchRect.top };
      priorOverflow = document.documentElement.style.overflow;
      viewer.showModal();
      document.documentElement.style.overflow = 'hidden';
      locked = true;
      populate();
      close.focus({ preventScroll: true });
      return true;
    };
    const release = () => {
      request?.abort();
      request = null;
      generation++;
      if (locked) document.documentElement.style.overflow = priorOverflow;
      locked = false;
      const anchorTarget = visible(launch) ? launch : null;
      const returnRoot = groupRoot;
      const returnTarget = anchorTarget || [...(returnRoot?.querySelectorAll('.el-source-media__image-link') || [])].find(visible);
      const returnScroll = launchScroll;
      const returnViewport = anchorTarget ? launchViewport : null;
      const returnToken = ++returnGeneration;
      returnActive = Boolean(returnScroll);
      if (returnTarget) returnTarget.focus({ preventScroll: true });
      if (returnScroll && (Math.abs(window.scrollX - returnScroll.left) > 1 || Math.abs(window.scrollY - returnScroll.top) > 1)) window.scrollTo({ ...returnScroll, behavior: 'instant' });
      let anchorLost = !anchorTarget || !returnViewport;
      let fallbackFocused = Boolean(returnTarget && returnTarget !== anchorTarget);
      const finishReturn = () => {
        if (returnToken === returnGeneration) returnActive = false;
      };
      const restoreReturnPosition = frame => {
        if (returnToken !== returnGeneration || !returnActive) return;
        if (!anchorLost && !visible(anchorTarget)) anchorLost = true;
        if (anchorLost) {
          if (!fallbackFocused) {
            const fallbackTarget = [...(returnRoot?.querySelectorAll('.el-source-media__image-link') || [])].find(target => target !== anchorTarget && visible(target));
            if (fallbackTarget) {
              fallbackTarget.focus({ preventScroll: true });
              fallbackFocused = true;
            }
          }
          if (returnScroll && (Math.abs(window.scrollX - returnScroll.left) > 1 || Math.abs(window.scrollY - returnScroll.top) > 1)) window.scrollTo({ ...returnScroll, behavior: 'instant' });
          if (frame < 12) requestAnimationFrame(() => restoreReturnPosition(frame + 1));
          else finishReturn();
          return;
        }
        const rect = anchorTarget.getBoundingClientRect();
        const deltaX = rect.left - returnViewport.left;
        const deltaY = rect.top - returnViewport.top;
        if (Math.abs(deltaX) > 1 || Math.abs(deltaY) > 1) window.scrollBy({ left: deltaX, top: deltaY, behavior: 'instant' });
        if (frame < 12) requestAnimationFrame(() => restoreReturnPosition(frame + 1));
        else finishReturn();
      };
      if (returnActive) requestAnimationFrame(() => restoreReturnPosition(0));
      launch = null;
      launchScroll = null;
      launchViewport = null;
      group = [];
      groupRoot = null;
    };
    const nativeClose = viewer.close.bind(viewer);
    const closeViewer = returnValue => {
      if (!viewer.open) return;
      pendingCloseEvents++;
      nativeClose(returnValue);
      release();
    };
    viewer.close = closeViewer;
    const move = direction => {
      if (!viewer.open) return;
      const destination = index + direction;
      if (destination < 0 || destination >= group.length) return;
      index = destination;
      populate();
    };
    const sync = () => {
      section.querySelectorAll('[data-source-mobile-url]').forEach(link => {
        const item = record(link);
        if (!item) return;
        link.href = item.url;
        link.setAttribute('aria-label', `${section.dataset.sourceOpenLabel}: ${item.alt}`);
        const sourceImage = link.querySelector('img');
        if (sourceImage) sourceImage.alt = item.alt;
      });
      if (viewer.open && groupRoot) {
        const currentLink = group[index]?.link;
        group = readGroup();
        if (!group.length) { viewer.close(); return; }
        const match = group.findIndex(item => item.link === currentLink);
        index = match >= 0 ? match : Math.min(index, group.length - 1);
        populate();
      }
    };
    const revealTarget = target => {
      if (!target || !section.contains(target)) return false;
      let node = target;
      let changed = false;
      while (node && node !== section) {
        if (node.matches('[data-source-disclosure]') && !node.open) { node.open = true; changed = true; }
        node = node.parentElement;
      }
      return changed;
    };
    const revealHash = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const target = id && document.getElementById(id);
      if (target && revealTarget(target)) requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };
    if (typeof viewer.showModal === 'function') {
      section.querySelectorAll('.el-source-media__image-link').forEach(link => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        on(link, 'click', event => {
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (open(link)) event.preventDefault();
        });
        on(link, 'dblclick', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (open(link)) event.preventDefault();
        });
        on(link, 'keydown', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (event.key === ' ' || event.key === 'Enter') { if (open(link)) event.preventDefault(); }
        });
      });
      on(close, 'click', () => viewer.close());
      on(viewer, 'close', () => {
        if (pendingCloseEvents) { pendingCloseEvents--; return; }
        if (!viewer.open) release();
      });
      on(viewer, 'cancel', event => { event.preventDefault(); viewer.close(); });
      on(previous, 'click', () => move(-1));
      on(next, 'click', () => move(1));
      on(retry, 'click', populate);
      on(viewer, 'keydown', event => {
        if (event.metaKey || event.ctrlKey || event.altKey || event.isComposing) return;
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); viewer.close(); }
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); event.stopPropagation(); move(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      on(stage, 'click', () => {
        if (stage.disabled) return;
        const expanded = stage.getAttribute('aria-pressed') !== 'true';
        stage.setAttribute('aria-pressed', String(expanded));
        stage.setAttribute('aria-label', expanded ? section.dataset.sourceFitLabel : section.dataset.sourceZoomInLabel);
        if (!expanded) fit();
      });
      on(image, 'error', () => { if (viewer.open && viewer.dataset.sourceState === 'ready') fail(); });
    }
    on(media, 'change', sync);
    window.addEventListener('wheel', cancelReturn, { signal: controller.signal, passive: true });
    window.addEventListener('touchstart', cancelReturn, { signal: controller.signal, passive: true });
    window.addEventListener('pointerdown', cancelReturn, { signal: controller.signal, passive: true });
    on(window, 'keydown', event => { if (!viewer.contains(event.target)) cancelReturn(); });
    on(window, 'hashchange', revealHash);
    on(section, 'shopify:block:select', event => revealTarget(event.target));
    activeSections.set(section, () => {
      if (viewer.open) closeViewer();
      else if (launch || locked || request) release();
      cancelReturn();
      delete viewer.close;
      controller.abort();
    });
    sync();
    revealHash();
  }
  function mount(root) {
    if (root.matches?.('[data-source-media]')) setup(root);
    root.querySelectorAll('[data-source-media]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const sections = event.target.matches?.('[data-source-media]') ? [event.target] : event.target.querySelectorAll('[data-source-media]');
    sections.forEach(section => { activeSections.get(section)?.(); activeSections.delete(section); });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easylonger-product-sticky"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('el-product-dock')) {
    customElements.define('el-product-dock', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.start = () => {
          if (!this.isConnected || this.started) return;
          this.started = true;
          try { this.variants = JSON.parse(this.querySelector('[data-dock-variants]').textContent); } catch { this.variants = []; }
          this.button = this.querySelector('[data-dock-add]');
          this.fallback = this.querySelector('[data-dock-fallback]');
          this.notify = this.querySelector('[data-dock-notify]');
          this.status = this.querySelector('[data-dock-status]');
          this.price = this.querySelector('[data-dock-price]');
          this.priceLabel = this.querySelector('[data-dock-price-label]');
          this.compare = this.querySelector('[data-dock-compare]');
          this.comparePrice = this.querySelector('[data-dock-compare-price]');
          this.quantity = this.querySelector('[data-dock-quantity]');
          this.variantName = this.querySelector('[data-dock-variant]');
          this.nav = this.querySelector('.el-product-dock__nav');
          this.purchase = this.querySelector('.el-product-dock__purchase');
          this.clearance = document.createElement('div');
          this.clearance.setAttribute('aria-hidden', 'true');
          this.clearance.dataset.elProductDockClearance = '';
          document.body.append(this.clearance);
          this.bindForm();
          this.button.addEventListener('click', () => this.add(), { signal });
          document.addEventListener('easylonger:camping-change', () => this.sync(), { signal });
          this.querySelectorAll('a[href^="#"]').forEach((link) => {
            const target = document.getElementById(link.hash.slice(1));
            if (!target && link.closest('nav')) { link.hidden = true; return; }
            link.addEventListener('click', (event) => {
              let parent = target?.parentElement;
              while (parent) { if (parent.tagName === 'DETAILS') parent.open = true; parent = parent.parentElement; }
              if (target?.matches('[data-product-support]')) {
                event.preventDefault();
                target.scrollIntoView({ block: 'start', behavior: 'instant' });
              }
            }, { signal });
          });
          this.nav.hidden = !Array.from(this.nav.querySelectorAll('a')).some((link) => !link.hidden);
          const targets = Array.from(this.nav.querySelectorAll('a:not([hidden])')).map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean).sort((first, second) => first.compareDocumentPosition(second) & 4 ? -1 : 1);
          this.updateCurrent = () => {
            this.navFrame = null;
            if (!this.isConnected) return;
            const navBottom = this.nav.getBoundingClientRect().bottom;
            const line = this.dataset.placement === 'bottom' ? Math.min(window.innerHeight * 0.2, 140) : Math.max(16, Math.min(navBottom + 16, window.innerHeight * 0.4));
            const positions = targets.map((target) => ({ target, rect: target.getBoundingClientRect() }));
            let current = positions.filter((item) => item.rect.top <= line).at(-1);
            if (!current || current.rect.bottom <= line) {
              current = positions.find((item) => item.rect.top > line && item.rect.top < window.innerHeight) || current;
            }
            this.nav.querySelectorAll('a').forEach((link) => {
              if (current && link.hash === '#' + current.target.id) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
            });
          };
          this.scheduleCurrent = () => {
            if (this.navFrame == null) this.navFrame = requestAnimationFrame(this.updateCurrent);
          };
          window.addEventListener('scroll', this.scheduleCurrent, { signal, passive: true });
          window.addEventListener('hashchange', this.scheduleCurrent, { signal });
          document.addEventListener('toggle', this.scheduleCurrent, { signal, capture: true });
          this.measure = () => {
            const height = Math.ceil((this.dataset.placement === 'bottom' ? this : this.purchase).getBoundingClientRect().height);
            const navHeight = this.dataset.placement === 'bottom' ? 0 : Math.ceil(this.nav.getBoundingClientRect().height);
            document.documentElement.style.setProperty('--el-product-dock-height', height + 'px');
            document.documentElement.style.setProperty('--el-product-nav-height', navHeight + 'px');
            this.clearance.style.height = height + 'px';
            this.scheduleCurrent();
          };
          if ('ResizeObserver' in window) {
            this.resizeObserver = new ResizeObserver(this.measure);
            this.resizeObserver.observe(this.purchase);
            this.resizeObserver.observe(this.nav);
            targets.forEach((target) => this.resizeObserver.observe(target));
          }
          window.addEventListener('resize', this.measure, { signal, passive: true });
          document.addEventListener('shopify:section:load', () => this.bindForm(), { signal });
          window.addEventListener('pageshow', () => this.sync(), { signal });
          this.measure();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true, signal });
        else this.start();
      }

      bindForm() {
        const hero = Array.from(document.querySelectorAll('[data-el-product-v3-hero]')).find((item) => item.dataset.productHandle === this.dataset.productHandle);
        const form = hero?.querySelector('form.el-product-v8__form');
        if (form === this.form) { this.sync(); return; }
        this.formController?.abort();
        this.formObserver?.disconnect();
        this.form = form;
        this.hero = hero;
        if (!form) { this.sync(); return; }
        this.formController = new AbortController();
        const signal = this.formController.signal;
        const afterChange = () => queueMicrotask(() => { if (this.isConnected) this.sync(); });
        ['input', 'change', 'click', 'variant:change', 'submit'].forEach((name) => form.addEventListener(name, afterChange, { signal }));
        form.addEventListener('cart:progress', (event) => {
          if (event.detail.message || !this.form.querySelector('[data-el-cart-error]')) {
            this.status.dataset.progress = String(Boolean(event.detail.message));
            this.status.textContent = event.detail.message;
          }
        }, { signal });
        form.addEventListener('cart:error', () => {
          this.status.dataset.progress = 'false';
          this.status.textContent = this.dataset.errorLabel;
          this.returnToForm(true);
          this.sync();
        }, { signal });
        form.addEventListener('variant:add', () => { this.status.textContent = ''; this.sync(); }, { signal });
        this.formObserver = new MutationObserver(afterChange);
        this.formObserver.observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-busy', 'value', 'selected'] });
        this.sync();
      }

      readState() {
        const form = this.form;
        const source = form?.querySelector('button[type="submit"].el-product-v8__add');
        const selected = form?.elements.namedItem('id');
        const variant = this.variants.find((item) => String(item.id) === String(selected?.value));
        const quantity = Number(form?.elements.namedItem('quantity')?.value || 1);
        const validQuantity = Number.isInteger(quantity) && quantity > 0;
        const busy = source?.getAttribute('aria-busy') === 'true' || form?.getAttribute('aria-busy') === 'true';
        const ready = Boolean(form?.isConnected && source && variant && validQuantity);
        return { source, variant, quantity, busy, ready };
      }

      sync() {
        if (!this.button) return;
        const state = this.readState();
        this.button.hidden = !this.form?.isConnected;
        this.fallback.hidden = !this.button.hidden;
        this.button.disabled = state.busy || Boolean(state.source?.disabled) || Boolean(state.variant && !state.variant.available);
        this.button.setAttribute('aria-busy', String(state.busy));
        this.button.textContent = state.busy ? this.dataset.addingLabel : !state.variant ? this.dataset.optionsLabel : !state.variant.available ? this.dataset.soldLabel : this.dataset.addLabel;
        this.notify.hidden = !(state.variant && !state.variant.available);
        if (state.variant) {
          const count = Number.isInteger(state.quantity) && state.quantity > 0 ? state.quantity : 1;
          const camping = window.ELCampingOffer?.applies(this.dataset.productHandle, state.variant.id);
          const compareAtPrice = camping ? state.variant.price : Number(state.variant.compareAtPrice || 0);
          const onSale = camping || compareAtPrice > state.variant.price;
          const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(cents * count / 100);
          this.variantName.textContent = state.variant.default ? '' : state.variant.title;
          this.priceLabel.textContent = onSale ? this.dataset.salePriceLabel : this.dataset.regularPriceLabel;
          this.price.textContent = camping ? new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' }).format(window.ELCampingOffer.total(state.variant.price, count) / 100) : format(state.variant.price);
          this.compare.hidden = !onSale;
          this.comparePrice.textContent = onSale ? format(compareAtPrice) : '';
          this.quantity.hidden = state.quantity <= 1 || !Number.isInteger(state.quantity);
          this.quantity.textContent = this.dataset.quantityLabel.replace('[count]', String(state.quantity));
        } else {
          this.variantName.textContent = this.dataset.optionsLabel;
          this.price.textContent = '';
          this.compare.hidden = true;
          this.comparePrice.textContent = '';
          this.quantity.hidden = true;
        }
      }

      returnToForm(error = false) {
        const target = error ? this.form?.querySelector('[data-el-cart-error]') : this.form?.querySelector('select[name="id"], input[name="quantity"]');
        const purchase = document.getElementById('purchase');
        (target || purchase)?.scrollIntoView({ block: 'center', behavior: 'auto' });
        if (target) {
          if (error) target.setAttribute('tabindex', '-1');
          target.focus({ preventScroll: true });
        } else if (purchase) window.location.hash = 'purchase';
      }

      add() {
        this.sync();
        const state = this.readState();
        if (state.busy || (state.ready && !state.variant.available)) return;
        if (!state.ready || state.source.disabled || typeof this.form.requestSubmit !== 'function') { this.returnToForm(); return; }
        if (!this.form.checkValidity()) { this.returnToForm(); this.form.reportValidity(); return; }
        this.status.textContent = '';
        try { this.form.requestSubmit(state.source); } catch { this.returnToForm(); }
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.formController?.abort();
        this.formObserver?.disconnect();
        this.resizeObserver?.disconnect();
        if (this.navFrame != null) cancelAnimationFrame(this.navFrame);
        this.navFrame = null;
        this.clearance?.remove();
        if (!document.querySelector('el-product-dock')) {
          document.documentElement.style.removeProperty('--el-product-dock-height');
          document.documentElement.style.removeProperty('--el-product-nav-height');
        }
        this.controller = null;
        this.form = null;
        this.started = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easylonger-product-stories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const activeSections = new WeakMap();
  function setup(section) {
    if (activeSections.has(section)) return;
    const viewer = section.querySelector('[data-source-viewer]');
    const image = viewer?.querySelector('[data-source-viewer-image]');
    const stage = viewer?.querySelector('[data-source-scale]');
    const viewport = viewer?.querySelector('[data-source-viewport]');
    const close = viewer?.querySelector('[data-source-close]');
    if (!viewer || !image || !stage || !viewport || !close) return;
    const controller = new AbortController();
    const on = (element, type, handler) => element?.addEventListener(type, handler, { signal: controller.signal });
    const media = window.matchMedia('(max-width: 767px)');
    const previous = viewer.querySelector('[data-source-prev]');
    const next = viewer.querySelector('[data-source-next]');
    const position = viewer.querySelector('[data-source-position]');
    const loading = viewer.querySelector('[data-source-loading]');
    const error = viewer.querySelector('[data-source-image-error]');
    const retry = viewer.querySelector('[data-source-retry]');
    const title = viewer.querySelector('[data-source-viewer-title]');
    let launch = null;
    let groupRoot = null;
    let group = [];
    let index = 0;
    let priorOverflow = '';
    let launchScroll = null;
    let launchViewport = null;
    let locked = false;
    let request = null;
    let generation = 0;
    let returnGeneration = 0;
    let returnActive = false;
    let pendingCloseEvents = 0;

    const record = link => {
      if (media.matches && link.closest('.el-story-desktop-only')) return null;
      const original = link.querySelector('img');
      const mobileSource = link.querySelector('source');
      const mobile = media.matches && Boolean(link.dataset.sourceMobileUrl);
      const url = mobile ? link.dataset.sourceMobileUrl : link.dataset.sourceDesktopUrl || link.getAttribute('href');
      if (!url || !original) return null;
      return {
        link,
        url,
        alt: (mobile ? link.dataset.sourceMobileAlt : link.dataset.sourceDesktopAlt) || original.alt || '',
        title: link.dataset.sourceTitle || '',
        width: Math.max(1, Number((mobile ? mobileSource : original)?.getAttribute('width')) || 1),
        height: Math.max(1, Number((mobile ? mobileSource : original)?.getAttribute('height')) || 1)
      };
    };
    const readGroup = () => [...groupRoot.querySelectorAll('.el-source-media__image-link')].map(record).filter(Boolean);
    const fit = () => {
      stage.setAttribute('aria-pressed', 'false');
      stage.setAttribute('aria-label', section.dataset.sourceZoomInLabel);
      viewport.scrollTop = 0;
      viewport.scrollLeft = 0;
    };
    const navigation = () => {
      if (previous) { previous.hidden = group.length < 2; previous.setAttribute('aria-disabled', String(index === 0)); }
      if (next) { next.hidden = group.length < 2; next.setAttribute('aria-disabled', String(index === group.length - 1)); }
      if (position) position.textContent = (viewer.dataset.sourcePositionTemplate || '__CURRENT__ / __TOTAL__').replace('__CURRENT__', String(index + 1)).replace('__TOTAL__', String(group.length));
    };
    const fail = () => {
      viewer.dataset.sourceState = 'error';
      viewport.setAttribute('aria-busy', 'false');
      image.hidden = true;
      stage.disabled = true;
      if (loading) loading.hidden = true;
      if (error) error.hidden = false;
    };
    const populate = () => {
      const item = group[index];
      if (!item) return;
      request?.abort();
      request = new AbortController();
      const token = ++generation;
      viewer.dataset.sourceState = 'loading';
      viewport.setAttribute('aria-busy', 'true');
      if (loading) loading.hidden = false;
      if (error) error.hidden = true;
      image.hidden = true;
      image.width = item.width;
      image.height = item.height;
      image.alt = item.alt;
      stage.disabled = true;
      if (title) title.textContent = item.title || item.alt;
      fit();
      navigation();
      const loader = new Image();
      loader.decoding = 'async';
      loader.addEventListener('load', () => {
        if (token !== generation || !viewer.open) return;
        image.width = loader.naturalWidth || item.width;
        image.height = loader.naturalHeight || item.height;
        image.src = item.url;
        stage.style.setProperty('--source-native-width', `${image.width}px`);
        viewer.dataset.sourceState = 'ready';
        viewport.setAttribute('aria-busy', 'false');
        if (loading) loading.hidden = true;
        image.hidden = false;
        stage.disabled = false;
      }, { signal: request.signal, once: true });
      loader.addEventListener('error', () => {
        if (token === generation && viewer.open) fail();
      }, { signal: request.signal, once: true });
      loader.src = item.url;
    };
    const visible = target => target?.isConnected && target.getClientRects().length && window.getComputedStyle(target).visibility !== 'hidden';
    const cancelReturn = () => {
      if (!returnActive) return;
      returnActive = false;
      returnGeneration++;
    };
    const open = link => {
      if (typeof viewer.showModal !== 'function') return false;
      if (viewer.open) return true;
      groupRoot = section;
      group = readGroup();
      index = group.findIndex(item => item.link === link);
      if (index < 0) return false;
      launch = link;
      returnActive = false;
      returnGeneration++;
      launchScroll = { left: window.scrollX, top: window.scrollY };
      const launchRect = link.getBoundingClientRect();
      launchViewport = { left: launchRect.left, top: launchRect.top };
      priorOverflow = document.documentElement.style.overflow;
      viewer.showModal();
      document.documentElement.style.overflow = 'hidden';
      locked = true;
      populate();
      close.focus({ preventScroll: true });
      return true;
    };
    const release = () => {
      request?.abort();
      request = null;
      generation++;
      if (locked) document.documentElement.style.overflow = priorOverflow;
      locked = false;
      const anchorTarget = visible(launch) ? launch : null;
      const returnRoot = groupRoot;
      const returnTarget = anchorTarget || [...(returnRoot?.querySelectorAll('.el-source-media__image-link') || [])].find(visible);
      const returnScroll = launchScroll;
      const returnViewport = anchorTarget ? launchViewport : null;
      const returnToken = ++returnGeneration;
      returnActive = Boolean(returnScroll);
      if (returnTarget) returnTarget.focus({ preventScroll: true });
      if (returnScroll && (Math.abs(window.scrollX - returnScroll.left) > 1 || Math.abs(window.scrollY - returnScroll.top) > 1)) window.scrollTo({ ...returnScroll, behavior: 'instant' });
      let anchorLost = !anchorTarget || !returnViewport;
      let fallbackFocused = Boolean(returnTarget && returnTarget !== anchorTarget);
      const finishReturn = () => {
        if (returnToken === returnGeneration) returnActive = false;
      };
      const restoreReturnPosition = frame => {
        if (returnToken !== returnGeneration || !returnActive) return;
        if (!anchorLost && !visible(anchorTarget)) anchorLost = true;
        if (anchorLost) {
          if (!fallbackFocused) {
            const fallbackTarget = [...(returnRoot?.querySelectorAll('.el-source-media__image-link') || [])].find(target => target !== anchorTarget && visible(target));
            if (fallbackTarget) {
              fallbackTarget.focus({ preventScroll: true });
              fallbackFocused = true;
            }
          }
          if (returnScroll && (Math.abs(window.scrollX - returnScroll.left) > 1 || Math.abs(window.scrollY - returnScroll.top) > 1)) window.scrollTo({ ...returnScroll, behavior: 'instant' });
          if (frame < 12) requestAnimationFrame(() => restoreReturnPosition(frame + 1));
          else finishReturn();
          return;
        }
        const rect = anchorTarget.getBoundingClientRect();
        const deltaX = rect.left - returnViewport.left;
        const deltaY = rect.top - returnViewport.top;
        if (Math.abs(deltaX) > 1 || Math.abs(deltaY) > 1) window.scrollBy({ left: deltaX, top: deltaY, behavior: 'instant' });
        if (frame < 12) requestAnimationFrame(() => restoreReturnPosition(frame + 1));
        else finishReturn();
      };
      if (returnActive) requestAnimationFrame(() => restoreReturnPosition(0));
      launch = null;
      launchScroll = null;
      launchViewport = null;
      group = [];
      groupRoot = null;
    };
    const nativeClose = viewer.close.bind(viewer);
    const closeViewer = returnValue => {
      if (!viewer.open) return;
      pendingCloseEvents++;
      nativeClose(returnValue);
      release();
    };
    viewer.close = closeViewer;
    const move = direction => {
      if (!viewer.open) return;
      const destination = index + direction;
      if (destination < 0 || destination >= group.length) return;
      index = destination;
      populate();
    };
    const sync = () => {
      section.querySelectorAll('[data-source-mobile-url]').forEach(link => {
        const item = record(link);
        if (!item) return;
        link.href = item.url;
        link.setAttribute('aria-label', `${section.dataset.sourceOpenLabel}: ${item.title || item.alt}`);
        const sourceImage = link.querySelector('img');
        if (sourceImage) sourceImage.alt = item.alt;
      });
      if (viewer.open && groupRoot) {
        const currentLink = group[index]?.link;
        group = readGroup();
        if (!group.length) { viewer.close(); return; }
        const match = group.findIndex(item => item.link === currentLink);
        index = match >= 0 ? match : Math.min(index, group.length - 1);
        populate();
      }
    };
    const revealTarget = target => {
      if (!target || !section.contains(target)) return false;
      let node = target;
      let changed = false;
      while (node && node !== section) {
        if (node.matches('[data-source-disclosure]') && !node.open) { node.open = true; changed = true; }
        node = node.parentElement;
      }
      return changed;
    };
    const revealHash = () => {
      let id;
      try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const target = id && document.getElementById(id);
      if (target && revealTarget(target)) requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };
    if (typeof viewer.showModal === 'function') {
      section.querySelectorAll('.el-source-media__image-link').forEach(link => {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        on(link, 'click', event => {
          if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (open(link)) event.preventDefault();
        });
        on(link, 'dblclick', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (open(link)) event.preventDefault();
        });
        on(link, 'keydown', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          if (event.key === ' ' || event.key === 'Enter') { if (open(link)) event.preventDefault(); }
        });
      });
      on(close, 'click', () => viewer.close());
      on(viewer, 'close', () => {
        if (pendingCloseEvents) { pendingCloseEvents--; return; }
        if (!viewer.open) release();
      });
      on(viewer, 'cancel', event => { event.preventDefault(); viewer.close(); });
      on(previous, 'click', () => move(-1));
      on(next, 'click', () => move(1));
      on(retry, 'click', populate);
      on(viewer, 'keydown', event => {
        if (event.metaKey || event.ctrlKey || event.altKey || event.isComposing) return;
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); viewer.close(); }
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); event.stopPropagation(); move(event.key === 'ArrowLeft' ? -1 : 1); }
      });
      on(stage, 'click', () => {
        if (stage.disabled) return;
        const expanded = stage.getAttribute('aria-pressed') !== 'true';
        stage.setAttribute('aria-pressed', String(expanded));
        stage.setAttribute('aria-label', expanded ? section.dataset.sourceFitLabel : section.dataset.sourceZoomInLabel);
        if (!expanded) fit();
      });
      on(image, 'error', () => { if (viewer.open && viewer.dataset.sourceState === 'ready') fail(); });
    }
    on(media, 'change', sync);
    window.addEventListener('wheel', cancelReturn, { signal: controller.signal, passive: true });
    window.addEventListener('touchstart', cancelReturn, { signal: controller.signal, passive: true });
    window.addEventListener('pointerdown', cancelReturn, { signal: controller.signal, passive: true });
    on(window, 'keydown', event => { if (!viewer.contains(event.target)) cancelReturn(); });
    on(window, 'hashchange', revealHash);
    on(section, 'shopify:block:select', event => revealTarget(event.target));
    activeSections.set(section, () => {
      if (viewer.open) closeViewer();
      else if (launch || locked || request) release();
      cancelReturn();
      delete viewer.close;
      controller.abort();
    });
    sync();
    revealHash();
  }
  function mount(root) {
    if (root.matches?.('[data-source-media]')) setup(root);
    root.querySelectorAll('[data-source-media]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), { once: true });
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    const sections = event.target.matches?.('[data-source-media]') ? [event.target] : event.target.querySelectorAll('[data-source-media]');
    sections.forEach(section => { activeSections.get(section)?.(); activeSections.delete(section); });
  });
})();

(() => {
  const mounted = new WeakMap();
  function mount(root) {
    if (mounted.has(root)) return;
    const abort = new AbortController();
    const pickers = [];
    root.querySelectorAll('[data-story-picker]').forEach((picker, group) => {
      const controls = picker.querySelector('[data-story-controls]');
      const tabs = [...controls.querySelectorAll('[data-story-tab]')];
      const panels = [...picker.querySelectorAll('[data-story-panel]')];
      if (!tabs.length || tabs.length !== panels.length) return;
      controls.setAttribute('role', 'tablist');
      const prefix = `${root.id}-${picker.dataset.storyGroup || group}`;
      tabs.forEach((tab, i) => {
        tab.id = `story-tab-${prefix}-${i}`;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-label', tab.textContent.trim());
        tab.setAttribute('aria-controls', `story-panel-${prefix}-${i}`);
        panels[i].id = `story-panel-${prefix}-${i}`;
        panels[i].setAttribute('role', 'tabpanel');
        panels[i].setAttribute('aria-labelledby', tab.id);
        panels[i].tabIndex = 0;
      });
      function select(index, focus = false, reflect = false) {
        tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          panels[i].hidden = !active;
        });
        if (focus) tabs[index].focus({preventScroll:true});
        if (reflect) history.replaceState(null, '', `${location.pathname}${location.search}#${panels[index].id}`);
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(index, false, true), {signal:abort.signal});
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          else return;
          event.preventDefault();
          select(next, true, true);
        }, {signal:abort.signal});
      });
      select(0);
      picker.dataset.ready = 'true';
      pickers.push({tabs,panels,select});
    });
    function reveal(target) {
      if (!target || !root.contains(target)) return;
      for (const picker of pickers) {
        const index = picker.panels.findIndex(panel => panel === target || panel.contains(target));
        if (index >= 0) picker.select(index);
      }
      let node = target;
      while (node && node !== root) {
        if (node.tagName === 'DETAILS') node.open = true;
        node = node.parentElement;
      }
    }
    function readHash() {
      if (!location.hash) return;
      let id;
      try {id = decodeURIComponent(location.hash.slice(1));} catch {return;}
      const target = document.getElementById(id);
      reveal(target);
      if (target && root.contains(target) && target.matches('[data-story-panel]')) {
        requestAnimationFrame(() => target.scrollIntoView({block:'start',behavior:'instant'}));
      }
    }
    window.addEventListener('hashchange', readHash, {signal:abort.signal});
    root.addEventListener('shopify:block:select', event => reveal(event.target), {signal:abort.signal});
    readHash();
    mounted.set(root, () => abort.abort());
  }
  document.querySelectorAll('[data-stories]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-stories]').forEach(mount));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-stories]').forEach(root => {mounted.get(root)?.();mounted.delete(root);}));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["easylonger-rewards-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initializeRewardsPage(root) {
    if (!root || root.dataset.rewardsPageInitialized) return;
    root.dataset.rewardsPageInitialized = 'true';
    var tabs = Array.from(root.querySelectorAll('[data-reward-tab]'));
    var panels = Array.from(root.querySelectorAll('[role="tabpanel"]'));
    function selectTab(tab, moveFocus) {
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.id !== tab.getAttribute('aria-controls');
      });
      if (moveFocus) tab.focus();
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectTab(tab, false); });
      tab.addEventListener('keydown', function (event) {
        var next = index;
        if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        selectTab(tabs[next], true);
      });
    });
  }
  function initializeAll() { document.querySelectorAll('.el-rewards').forEach(initializeRewardsPage); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  else initializeAll();
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.el-rewards').forEach(initializeRewardsPage);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
